import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { useAppLoad } from "../../appLoadContext";
import { useResource, useFetcher } from "@rest-hooks/core";
import { ProofOfDeliveryInformationResource } from "@ploy-lib/rest-resources";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { ProofOfDeliverySmsActions } from "@ploy-ui/proof-of-delivery-views";
import { ErrorHandler } from "@ploy-lib/core";
import { ErrorPageContent } from "@ploy-ui/core";
import { useVariableData } from "@ploy-lib/calculation";
import { useFormikContext } from "formik";
addRegisteredSectionLayout({
    name: "SendDeliveryOfProofSection",
    displayName: "SendDeliveryOfProofSection",
    settings: { editableOptions: { showStatus: true } }
});
const SendDeliveryOfProofSectionInternal = (props) => {
    const { className, onClick, setSectionCompleted, formTemplateSectionId, fields } = props;
    const { applicationId, id: appSessionId } = useAppLoad();
    const { errors: formikErrors, touched: formikTouched } = useFormikContext();
    const [sectionError, setSectionError] = useState(false);
    useEffect(() => {
        if (fields.some(field => {
            const error = formikErrors?.[field.namespace ?? ""]?.[field.name];
            return error;
        })) {
            setSectionError(true);
        }
        else {
            setSectionError(false);
        }
    }, [formikErrors, formikTouched, fields, setSectionError]);
    const { value: registrationNumber } = useVariableData("Object", "RegNumber");
    const proofOfDeliveryDetails = useResource(ProofOfDeliveryInformationResource.detail(), appSessionId
        ? {
            applicationId
        }
        : null);
    const fetchProofOfDelivery = useFetcher(ProofOfDeliveryInformationResource.detail());
    const reload = useCallback(() => fetchProofOfDelivery({ applicationId: applicationId }), [fetchProofOfDelivery, applicationId]);
    const sectionCompleted = proofOfDeliveryDetails?.deliverySent || false;
    useEffect(() => {
        setSectionCompleted?.(formTemplateSectionId, sectionCompleted);
    }, [sectionCompleted, formTemplateSectionId, setSectionCompleted]);
    return (_jsx(ProofOfDeliverySmsActions, { loadedData: proofOfDeliveryDetails, className: className, onClick: onClick, reloadData: reload, regNumber: registrationNumber, errors: sectionError }));
};
const SendDeliveryOfProofSection = (props) => (_jsx(ErrorHandler, { fallback: e => (_jsx(ErrorPageContent, { className: props.className, onClick: props.onClick, header: _jsxs("span", { children: [SendDeliveryOfProofSection.displayName, " failed to render."] }) })), children: _jsx(SendDeliveryOfProofSectionInternal, { ...props }) }));
SendDeliveryOfProofSection.displayName = "DploySendDeliveryOfProofSection";
export { SendDeliveryOfProofSection };
//# sourceMappingURL=SendDeliveryOfProofSection.js.map